// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';
import queryString from 'query-string';

import { toast } from 'react-toastify';

export const getOutwordNo = createAsyncThunk('recordSlice/getOutwordNo', async () => {
    try {
        let response = await axios.get('/Records/record-number', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getCategoryOptions = createAsyncThunk('recordSlice/getCategoryOptions', async () => {
    try {
        let response = await axios.get('/Category?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getSubCategoryOptions = createAsyncThunk('recordSlice/getSubCategoryOptions', async () => {
    try {
        let response = await axios.get('/SubCategory?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getDocTypeOptions = createAsyncThunk('recordSlice/getDocTypeOptions', async () => {
    try {
        let response = await axios.get('/DocType?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getRecords = createAsyncThunk('recordSlice/getRecords', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/Records?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const getRecordsFilter = createAsyncThunk('recordSlice/getRecordsFilter', async (data) => {
    const query = queryString.stringify(data);

    try {
        let response = await axios.get('/Records?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createRecord = createAsyncThunk('recordSlice/createRecord', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Records', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Records added succesfully.');
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getSubCategoryBySelectedId = createAsyncThunk('recordSlice/getSubCategoryBySelectedId', async (id) => {
    try {
        let response = await axios.get('/SubCategory/sub-category/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getDayAdjustmentStatus = createAsyncThunk('recordSlice/getDayAdjustmentStatus', async () => {
    try {
        let response = await axios.get('/Taxmaster?status=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const deleteRecords = createAsyncThunk('recordSlice/deleteRecords', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Records/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Record deleted successfully.');
        await dispatch(getRecords());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateRecord = createAsyncThunk('recordSlice/updateRecord', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Records/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        toast.success(response?.data?.message || 'Record updated succesfully.');
        // await dispatch(getRecordsFilter());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateRecordsStatus = createAsyncThunk('recordSlice/updateRecordsStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/Records/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getRecords());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const recordSlice = createSlice({
    name: 'recordSlice',
    initialState: {
        recordsFilter: [],
        categoryoption: [],
        subCategoryoption: [],
        docTypeoption: [],
        recordsMaster: [],
        outWordNo: [],
        taxmasterStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getCategoryOptions.fulfilled, (state, action) => {
            state.categoryoption = action?.payload;
            return;
        });
        builder.addCase(getSubCategoryOptions.fulfilled, (state, action) => {
            state.subCategoryoption = action?.payload;
            return;
        });
        builder.addCase(getDocTypeOptions.fulfilled, (state, action) => {
            state.docTypeoption = action?.payload;
            return;
        });
        builder.addCase(getRecords.fulfilled, (state, action) => {
            state.recordsMaster = action?.payload;
            return;
        });
        builder.addCase(getRecordsFilter.fulfilled, (state, action) => {
            state.recordsFilter = action?.payload;
            return;
        });
        builder.addCase(getOutwordNo.fulfilled, (state, action) => {
            state.outWordNo = action?.payload;
            return;
        });
        builder.addCase(getDayAdjustmentStatus.fulfilled, (state, action) => {
            state.taxmasterStatus = action?.payload;
            return;
        });
    }
});

export default recordSlice.reducer;
